/* eslint-disable no-underscore-dangle */
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';

@Component
export class CartMainSummary extends ThemeComponent {
    @Ref() visibilityTrigger!: HTMLElement[];

    init() {

        // Listen for visibility trigger clicks
        this.listenForVisibilityTriggerClicks();

        // Listen for outer summary click
        this.listenForOuterSummaryClick();
    }

    listenForVisibilityTriggerClicks() {
        for (const visibilityTrigger of this.visibilityTrigger) {
            this.$listen(visibilityTrigger, 'click', (e) => {
                this.classList.toggle('cart-main-summary--active');
            });
        }
    }

    listenForOuterSummaryClick() {
        this.$listen(document.body, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement !== this && !this.contains(clickedElement)) {
                    this.classList.remove('cart-main-summary--active');
                }
            }
        });
    }
}
